import React from "react";
import flowerIcon from "../../../assets/images/flower.svg"; 
import gownImage from "../../../assets/images/sideimage.jpg"; 
import bgImage from "../../../assets/images/watercolor-paper-texture.jpg";
import '../../../assets/css/Bloomabout.css';

const WhyBloom = () => {
  return (
    <div className="whybloom-wrapper">
      <div
        className="whybloom-container"
        // style={{ backgroundImage: `url(${bgImage})` }}
      >
        {/* Left Side - Gown Image (Edge-to-edge) */}
        <div className="whybloom-left">
          <img src={gownImage} alt="Bloom Gown" className="gown-image" />
        </div>

        {/* Right Side - Text Content */}
        <div className="whybloom-right">
          <h2 className="whybloom-title">Why Bloom?</h2>
          <p className="whybloom-paragraph">
            When you're told you need a mastectomy, a thousand things race through
            your mind. What to wear shouldn't be one of them.
          </p>
          <p className="whybloom-paragraph">
            Bloom was created to ensure women leave the hospital not just with
            strength in their hearts, but grace in their appearance. What makes our
            customised Bloom gowns special:
          </p>

          <ul className="whybloom-list">
            {[
              "Hidden pockets for drains",
              "Soft seams that avoid pressure points",
              "Built-in gentle support (no bra needed)",
              "Front opening for ease of wear",
              "Elegant, uplifting design",
            ].map((item, index) => (
              <li key={index}>
                <img src={flowerIcon} alt="icon" />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <p className="whybloom-highlight">
            A gown made not just for recovery, but for reclaiming yourself.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyBloom;